import React, { useEffect, useContext } from 'react'
import './google_ad.css'
import GoogleAdCta from '../google-ad-cta'
import { GoogleAdContext } from './google-ad-context'

const GoogleAd = ({ adKey, adSource, adPosition, fromContent = false, isSidePanelAd = false }) => {
  const isDev = ['mt3.dev', 'ewnova.dev', 'localhost'].some((host) => window.location.hostname.endsWith(host))
  const currentRoute = window.location.pathname.split('/')[1]
  const key = `${adKey}#${adPosition}#${currentRoute}`
  const adClass = `mt-${adKey}-${adPosition}`

  const { pushedAds, previousRoute, setPreviousRoute } = useContext(GoogleAdContext)

  useEffect(() => {
    if (previousRoute && previousRoute !== currentRoute && pushedAds.current.size > 0) {
      console.log(pushedAds || 0)
      console.log('*CLEANUP Global vars`*')
      console.log('*CLEANUP`* [previousRoute]: %s - [currentRoute]: %s', previousRoute, currentRoute)
      console.log('*CLEANUP`* [pushedAds.current.size]: %i before clearing', pushedAds.current.size)
      console.log('*CLEANUP`* Clearing [pushedAds]...')
      pushedAds.current.clear()
      setPreviousRoute(null)
      console.log('*Cleanup Function* [pushedAds.current.size]: %i after clearing', pushedAds.current.size)
      console.log('*Cleanup Function* [previousRoute] after clearing', previousRoute)
    }

    if (pushedAds.current.has(key)) return

    try {
      const adSelector = isDev ? `div.adsbygoogle.${adClass}` : `ins.adsbygoogle.${adClass}`
      const targetAdSlot = document.querySelector(adSelector)

      if (!targetAdSlot) {
        console.log(`*SKIP* [targetAdSlot] found for [adClass]: ${adClass}`)
        return
      }

      console.log(`*ADD* [targetAdSlot] found for [adClass]: ${adClass}`, targetAdSlot)
      console.log('*ADD* GoogleAd [isSidePanelAd]', isSidePanelAd)

      if (isDev) {
        console.log(`*ADD* Ad slot found for [adClass]: ${adClass}`, targetAdSlot)
        console.log('*ADD* GoogleAd [previousRoute]: %s [currentRoute]: %s', previousRoute, currentRoute)
        console.log('*ADD* [pushedAds.current.size]: %i before adition', pushedAds.current.size)
        fromContent ? key.startsWith(currentRoute) && pushedAds.current.add(key) : pushedAds.current.add(key)
        console.log('*ADD* [pushedAds.current.size]: %i after adition', pushedAds.current.size)
        console.log('*** GoogleAd Component loaded ***')
        setPreviousRoute(currentRoute)
        return
      }

      if (!targetAdSlot.getAttribute('data-adsbygoogle-status')) {
        console.log(`*ADD* Ad slot found for [adClass]: ${adClass}`, targetAdSlot)
        console.log('*ADD* GoogleAd [previousRoute]: %s [currentRoute]: %s', previousRoute, currentRoute)
        console.log('*ADD* [pushedAds.current.size]: %i before adition', pushedAds.current.size)
        if (fromContent) {
          if (key.startsWith(currentRoute)) {
            (window.adsbygoogle = window.adsbygoogle || []).push({})
            console.log('*** GoogleAd Component loaded ***')
            pushedAds.current.add(key)
            console.log('*ADD* [pushedAds.current.size]: %i after adition', pushedAds.current.size)
          }
        } else {
          (window.adsbygoogle = window.adsbygoogle || []).push({})
          console.log('*** GoogleAd Component loaded ***')
          pushedAds.current.add(key)
          console.log('*ADD* [pushedAds.current.size]: %i after adition', pushedAds.current.size)
        }
        setPreviousRoute(currentRoute)
      }
    } catch (error) {
      console.debug('*** Google Adsense component error', error)
    }
  }, [adKey, adPosition, isDev, currentRoute, fromContent, isSidePanelAd, key, adClass, pushedAds, previousRoute, setPreviousRoute])

  if (isDev) {
    return (
      <>
        <div key={key} className='google_adsense_container_placeholder'>
          <div className={`adsbygoogle ${adClass}`}>
            PLACEHOLDER GOOGLE ADSENSE ADVERT<br />
            adSource: {adSource}<br />
            adKey: {adKey}<br />
            adPosition: {adPosition}<br />
            uniqueKey: {key}
          </div>
        </div>
        <GoogleAdCta isSidePanelAd={isSidePanelAd} />
      </>
    )
  }

  return (
    <>
      <div key={key} className='google_adsense_container'>
        <ins
          className={`adsbygoogle ${adClass}`}
          data-ad-client={process.env.REACT_APP_GOOGLE_ADSENSE_CLIENT}
          data-ad-slot={process.env.REACT_APP_GOOGLE_ADSENSE_SLOT}
          data-ad-format='auto'
          data-full-width-responsive='true'
        />
      </div>
      <GoogleAdCta isSidePanelAd={isSidePanelAd} />
    </>
  )
}

export default GoogleAd
